import { EditAttributeFormInModalProps } from "@/modules/dynamic-attributes/widgets/dynamic-attribute-editor/ui/edit-attribute-in-modal";
import { RemoveAttributeProps } from "@/modules/dynamic-attributes/widgets/dynamic-attribute-editor/ui/remove-attribute";
import { More } from "@/shared/actions/more";
import Table, {
  TableProps,
  useOptionsColumn,
} from "@/shared/data-display/table";
import { EntityAttributeListViewFragment } from "gql/graphql";
import { FC } from "react";
import { useTranslations } from "use-intl";
import { AttributeType } from "../../../shared/ui/attribute-type/attribute-type";

type EntityAttributeListViewProps =
  TableProps<EntityAttributeListViewFragment> & {
    RemoveAttribute: FC<RemoveAttributeProps>;
    EditAttribute?: FC<EditAttributeFormInModalProps>;
  };

export function EntityAttributeListView({
  EditAttribute,
  RemoveAttribute,
  ...rest
}: EntityAttributeListViewProps) {
  const t = useTranslations("EntityAttributeListView");

  const options = useOptionsColumn<EntityAttributeListViewFragment>({
    Options: ({ record }) => (
      <More
        menu={{
          items: [
            EditAttribute
              ? {
                  key: "edit form",
                  label: <EditAttribute attributeId={record.id} />,
                }
              : null,
            RemoveAttribute
              ? {
                  key: "remove",
                  label: <RemoveAttribute attributeId={record.id} />,
                }
              : null,
          ],
        }}
      />
    ),
  });

  return (
    <Table
      rowKey={(record) => record.id}
      {...rest}
      columns={[
        {
          key: "name",
          title: t("Name"),
          render: (_, { name }) => name.value,
        },
        {
          key: "description",
          title: t("Description"),
          render: (_, { description }) => description.value,
        },
        {
          key: "attribute type",
          title: t("Attribute type"),
          render: (_, record) => <AttributeType attribute={record} />,
        },
        options,
      ]}
    />
  );
}
